import React, { Fragment, useState, forwardRef } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { accordionSummaryStyles } from "../../forms/StyledComponents";
import { Card } from "react-bootstrap";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Loader } from "@egovernments/digit-ui-react-components";
import useDepartmentSelector from "../../hooks/useDepartmentSelector";
import { useTranslation } from "react-i18next";
import BPADocumentsPreview from "../../../../../../../templates/ApplicationDetails/components/BPADocumentsPreview";
import { getOrderDocuments } from "../../../../../utils";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const Summary = forwardRef(({ id }, ref) => {
  const history = useHistory();
  const { t } = useTranslation();
  const [, applicationFlow] = useDepartmentSelector();
  const [, setIsPreviewLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const formType = "PURCHASABLE_FAR";
  const { data = {}, isLoading, refetch } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee, formType }, { formType });
  const formData = data?.PurchasableFAR?.[0];
  const owners = formData?.landInfo?.owners;

  console.log(data, "fromSummary");
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  const docs = formData?.documents || {};
  const approvedLayout = formData?.approvedLayout === "Yes";

  const normalizeDocuments = (docs) => {
    if (docs && typeof docs === "object" && !Array.isArray(docs)) {
      return Object.values(docs);
    }
    return docs;
  };

  const documents = normalizeDocuments(docs);

  let improvedDoc = [];

  documents?.map((appDoc) => {
    improvedDoc.push({ ...appDoc, module: "OBPS" });
  });

  const { data: pdfDetails, isLoading: docsLoading } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: improvedDoc?.length > 0 ? true : false,
  });

  let applicationDocs = [];
  if (pdfDetails?.pdfFiles?.length > 0) {
    pdfDetails?.pdfFiles?.map((pdfAppDoc) => {
      if (pdfAppDoc?.module === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  const ownerInfo = formData?.landInfo?.owners?.[0];
  const descriptionOfLand = formData?.descriptionOfLand?.properties?.[0];
  console.log("description", descriptionOfLand);

  const checklist1 = formData?.checklist?.firstCheckList;
  const checklist2 = formData?.checklist?.secondCheckList;

  const step1Docs = applicationDocs.filter((doc) =>
    ["allotmentLetter", "possessionLetter", "registry", "hpta", "paymentStatus"].includes(doc.documentType)
  ); // removing photo and signature from documents
  const documentSection = applicationDocs.filter((doc) =>
    ["agreement", "allotmentLetter", "sitePlan", "kmlFile", "khataKhasraDocs", "possessionLetter", "registry", "hpta", "paymentStatus"].includes(
      doc.documentType
    )
  );
  const personalDocs = applicationDocs.filter((doc) => ["signature", "applicantPhoto"].includes(doc.documentType)); // extracting photo and signature from documents
  console.log("personalDOcs", personalDocs);
  const proposalDocument = applicationDocs?.filter((doc) => ["proposalDocument"].includes(doc.documentType))?.[0]?.fileStoreId;
  const drawingFile = applicationDocs?.filter((doc) => ["drawingFile"].includes(doc.documentType))?.[0]?.fileStoreId;
  const structuralCertificate = applicationDocs?.filter((doc) => ["structuralCertificate"].includes(doc.documentType))?.[0]?.fileStoreId;
  const fireDepartmentCertificate = applicationDocs?.filter((doc) => ["fireDepartmentCertificate"].includes(doc.documentType))?.[0]?.fileStoreId;

  if (!formData && docsLoading) return <Loader />;
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
      }}
      ref={ref}
    >
      <div style={{ display: "flex", padding: "5px", background: "rgb(230, 239, 248)" }}>
        <div style={{ background: "white", borderRadius: "50%" }}>
          <img width="60" height="30" src={urlImg} alt="Uttar-Pradesh-Logo" />
        </div>
        <div style={{ color: "#1f4a7c" }}>
          <p style={{ marginLeft: "12px", fontSize: "1.25rem", fontWeight: "600", fontFamily: "Montserrat" }}>{nameOfDepartment}</p>
          <p style={{ marginLeft: "12px", fontFamily: "Montserrat", fontWeight: "500" }}>Government of Uttar Pradesh</p>
        </div>
      </div>

      <div className="container1" style={{ width: "100%", marginTop: "1rem" }}>
        {
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("LABEL_APPLICANT_DETAILS")}</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  <div style={{ flex: "1 1 calc(50% - 10px)", marginRight: "10px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {ownerInfo?.name && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_NAME")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.name}</td>
                          </tr>
                        )}
                        {ownerInfo?.fatherOrHusbandName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_FATHER_NAME")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.fatherOrHusbandName}</td>
                          </tr>
                        )}
                        {ownerInfo?.gender && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_GENDER")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.gender}</td>
                          </tr>
                        )}
                        {ownerInfo?.mobileNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_MOBILE_NUMBER")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.mobileNumber}</td>
                          </tr>
                        )}
                        {ownerInfo?.emailId && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_EMAIL_ID")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.emailId}</td>
                          </tr>
                        )}
                        {ownerInfo?.aadhaarNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_AADHAR_CARD")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.aadhaarNumber}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.propertyNo && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PROPERTY_NO")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.propertyNo}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.plotArea && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PLOT_AREA")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotArea}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.town && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_CITY")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.town}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.address && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_ADDRESS")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.address}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.schemeName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Scheme")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.schemeName}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.state && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_STATE")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.state}</td>
                          </tr>
                        )}
                        {ownerInfo?.correspondenceAddress.pinno && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("LABEL_PIN_CODE")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{ownerInfo?.correspondenceAddress.pinno}</td>
                          </tr>
                        )}
                        {descriptionOfLand?.constructionType && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Construction Type")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.constructionType}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {owners?.map(
                    (item, index) =>
                      item?.photo && (
                        <div
                          key={index} // Added key for each item
                          style={{
                            flex: "1 1 calc(50% - 10px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            alignItems: "center",
                            padding: "24px",
                          }}
                        >
                          <div className="row" style={{ marginBottom: "10px" }}>
                            {item?.photo ? (
                              <img
                                style={{ width: "200px", height: "180px", objectFit: "cover" }}
                                src={item.photo}
                                alt="image"
                                className="img-thumbnail"
                              />
                            ) : (
                              <Avatar style={{ width: "200px", height: "80px" }}>{item?.photo}</Avatar>
                            )}
                          </div>
                          <div className="row" style={{ marginBottom: "10px", marginTop: "84px" }}>
                            {item?.signature ? (
                              <img style={{ width: "200px", height: "80px" }} src={item.signature} alt="signature" className="img-thumbnail" />
                            ) : (
                              <BorderColorIcon style={{ width: "70px", height: "25px" }}>{item?.signature}</BorderColorIcon>
                            )}
                          </div>
                        </div>
                      )
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        }

        {/* Applicant Information */}

        <Card className="formContainer">
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
              <div className="formHeaderContainer">
                <h2 className="formHeading">{t("Layout Details")}</h2>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {formData?.approvedLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_PLOT_PART_OF_APPROVED_LAYOUT")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{formData?.approvedLayout}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.landUseAsPerLayout && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_LAND_USE_AS_PER_LAYOUT")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landUseAsPerLayout}</td>
                        </tr>
                      )}
                      {/* {approvedLayout && (
                        <BPADocumentsPreview
                          documents={getOrderDocuments(step1Docs)}
                          svgStyles={{}}
                          isSendBackFlow={false}
                          isHrLine={true}
                          titleStyles={{ fontSize: "18px", lineHeight: "24px", fontWeight: 700, marginBottom: "10px" }}
                        />
                      )} */}

                      {!approvedLayout && (
                        <Fragment>
                          {descriptionOfLand?.khasraNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHASRA_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khasraNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.khatauniNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHATAUNI_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khatauniNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.khataNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_KHATA_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.khataNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.plotNo && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_PLOT_NO")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.plotNo}</td>
                            </tr>
                          )}
                          {descriptionOfLand?.landWidth && (
                            <tr>
                              <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                                <b>{t("LABEL_LAND_WIDTH")}</b>
                              </td>
                              <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.landWidth}</td>
                            </tr>
                          )}
                        </Fragment>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </Card>
        <Card className="formContainer">
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
              <div className="formHeaderContainer">
                <h2 className="formHeading">{t("FAR Details")}</h2>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      {descriptionOfLand?.takenFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_ALREADY_TAKEN_FAR")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.takenFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.takenFAR == "Yes" && descriptionOfLand?.purchasableFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_TAKEN_PURCHASABLE_FAR")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.purchasableFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.percentRequiredFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_REQUIRED_FAR_PERCENTAGE")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.percentRequiredFAR}</td>
                        </tr>
                      )}
                      {descriptionOfLand?.requiredAreaFAR && (
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("LABEL_REQUIRED_FAR_AREA")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{descriptionOfLand?.requiredAreaFAR}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </Card>
        {documentSection.length > 0 && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Documents Section")}</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer">
                  {
                    <BPADocumentsPreview
                      documents={getOrderDocuments(documentSection)}
                      svgStyles={{}}
                      isSendBackFlow={false}
                      isHrLine={true}
                      titleStyles={{ fontSize: "18px", lineHeight: "24px", fontWeight: 700, marginBottom: "10px" }}
                    />
                  }
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {checklist1?.setbackPosition?.front && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Checklist 1")}</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_SETBACK_POSITION")}</b>
                          </td>
                        </tr>

                        {checklist1?.setbackPosition?.front && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Front")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.front}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.rear && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Rear")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.rear}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.left && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Left")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.left}</td>
                          </tr>
                        )}
                        {checklist1?.setbackPosition?.right && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Right")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.setbackPosition?.right}</td>
                          </tr>
                        )}
                        {checklist1?.buildingHeight && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Height of Proposed Building (m)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.buildingHeight}</td>
                          </tr>
                        )}
                        {proposalDocument && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Proposal Document (PDF)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(proposalDocument, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {drawingFile && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Proposal Document (PDF)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(drawingFile, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {checklist1?.structuralSafety && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Structural Safety Certificate Applicable")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.structuralSafety}</td>
                          </tr>
                        )}
                        {structuralCertificate && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Structural Safety Certificate")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(structuralCertificate, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        {fireDepartmentCertificate && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Fire Department Certificate")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              {
                                <FaFilePdf
                                  color="#a10505"
                                  style={{ width: "20px", height: "30px" }}
                                  onClick={() => getDocumentByFileStoreId(fireDepartmentCertificate, setIsPreviewLoading)}
                                />
                              }
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ width: "100%", textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_PARKING_ARRANGEMENT")}</b>
                          </td>
                        </tr>
                        {checklist1?.totalParkingRequired && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{t("Total Parking Required (sq.m)")}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{checklist1?.totalParkingRequired}</td>
                          </tr>
                        )}

                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_PROVISION_PROPOSED_PLAN")}</b>
                          </td>
                        </tr>

                        <tr>
                          <td rowSpan={2} style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Basement")}</b>
                          </td>
                          {checklist1?.parkingProvision?.inBasement?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.inBasement?.cars}
                              </td>
                            </>
                          )}
                        </tr>
                        {checklist1?.parkingProvision?.inBasement?.ecs && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                              <b>{t("No. of ECS")}:</b>
                              {checklist1?.parkingProvision?.inBasement?.ecs}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <td rowSpan={2} style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Open Area")}</b>
                          </td>
                          {checklist1?.parkingProvision?.openArea?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.openArea?.cars}
                              </td>
                            </>
                          )}
                        </tr>
                        {checklist1?.parkingProvision?.openArea?.ecs && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                              <b>{t("No. of ECS")}:</b>
                              {checklist1?.parkingProvision?.openArea?.ecs}
                            </td>
                          </tr>
                        )}

                        <tr>
                          <td rowSpan={2} style={{ textAlign: "left", padding: "8px" }}>
                            <b>{t("In Stilt Area")}</b>
                          </td>
                          {checklist1?.parkingProvision?.inStiltArea?.cars && (
                            <>
                              <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                                <b>{t("No. of Cars")}:</b>
                                {checklist1?.parkingProvision?.inStiltArea?.cars}
                              </td>
                            </>
                          )}
                        </tr>
                        {checklist1?.parkingProvision?.inStiltArea?.ecs && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "center", padding: "8px" }}>
                              <b>{t("No. of ECS")}:</b>
                              {checklist1?.parkingProvision?.inStiltArea?.ecs}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {checklist2?.publicSewerageOrSepticTank && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">{t("Checklist 2")}</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_SEWERAGE_STORMWATER")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Public sewerage plan or septic tank")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.publicSewerageOrSepticTank ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Proposed drainage plan approval")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.drainagePlanApproval ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_ROAD_CONNECTIVITY")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Existing road width in meters")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.existingRoadWidth || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Minimum 24 meters wide")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.minimum24MetersWide ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_WATER_SUPPLY")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Water supply arrangement (capacity in liters per day)")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.waterSupplyArrangement || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Water supply plan as per requirements")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.waterSupplyPlanApproval ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_SEWERAGE_DISPOSAL")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("STP/Septic tank arrangement made by applicant. Or Establish Connectivity with Govt. Authority")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.stpSepticTankArrangement ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>
                              {t("Yes / No, confirms to standards / not. It is proposed to establish connectivity with the Government Authority.")}
                            </b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.connectivityWithGovernmentAuthority ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_DRAINAGE_SYSTEM_COMPLIANCE")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("The proposed system is as per the standards or the government agency has approved connectivity.")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.drainageSystemComplianceWithStandards ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("As per standards / not.")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.drainageAsPerStandards ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_POWER_SUPPLY")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Total estimated power demand (kW/MW)")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.totalEstimatedPowerDemand || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Corporation Ltd. has consent for supply in respect of proposed Garg. Power received")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.powerSupplyConsent ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_RAINWATER_HARVESTING_SYSTEM")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Total area of rooftop (sq. meters) and provision of drain pipe and recharge pit")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.rooftopAreaAndDrainage || ""}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Found to be as per standard / not")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.drainageStandardsCompliance ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="table-subheader" style={{ textAlign: "center", padding: "8px" }}>
                            <b>{t("LABEL_SOLAR_WATER_SYSTEM")}</b>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>
                              {t(
                                "Provision of pipes in the building design for solar water heating system and determination of suitable location for the plant on the rooftop."
                              )}
                            </b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.solarWaterHeatingProvision ? "Yes" : "No"}</td>
                        </tr>
                        <tr>
                          <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                            <b>{t("Whether provision made as per building bye-laws or not")}</b>
                          </td>
                          <td style={{ width: "50%", padding: "8px" }}>{checklist2?.buildingByeLawsCompliance ? "Yes" : "No"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {(formData?.descriptionOfLand?.googleMapCoordinates || formData?.descriptionOfLand?.googleMapLocation) && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Location Information</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Map Cordinates:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>
                              Latitude: {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.latitude}, Longitude:{" "}
                              {formData?.descriptionOfLand?.googleMapCoordinates?.[0]?.longitude}
                            </td>
                          </tr>
                        )}
                        {formData?.descriptionOfLand?.googleMapLocation && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>Map Location:</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.descriptionOfLand?.googleMapLocation}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {formData?.assignLTP === "Yes" && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Assign file to License Technical Person(LTP)</h2>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ width: "100%" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        {formData?.professionalInformation?.ltpName && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("Selected LTP")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpName}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.ltpRegistrationNumber && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("Registration No.")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpRegistrationNumber}</td>
                          </tr>
                        )}
                        {formData?.professionalInformation?.ltpCity && (
                          <tr>
                            <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                              <b>{`${t("City Name")} :`}</b>
                            </td>
                            <td style={{ width: "50%", padding: "8px" }}>{formData?.professionalInformation?.ltpCity}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
        {Boolean(formData?.taxHeadEstimates?.[0]?.estimateAmount) && (
          <Card className="formContainer">
            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={accordionSummaryStyles}>
                <div className="formHeaderContainer">
                  <h2 className="formHeading">Processing Fee for Purchasable FAR</h2>
                </div>
              </AccordionSummary>

              <AccordionDetails>
                <div className="formInputContainer">
                  <div style={{ display: "flex" }}>
                    <b>Total Amount</b>
                    <p style={{ marginLeft: "1rem" }}>
                      <span>₹ {formData?.taxHeadEstimates?.[0]?.estimateAmount}</span>
                    </p>
                  </div>
                </div>
              </AccordionDetails>
            </Accordion>
          </Card>
        )}
      </div>
    </div>
  );
});

export default Summary;
